import React, { Component } from 'react';
import { connect } from 'react-redux';
import { actions, errorMessages, deviceMessages } from '../../../helpers/messages';

class DeviceDetailsUploadComponent extends Component {
    constructor(props) {
        super(props)
        this.inputOpenFileRef = React.createRef();
        this.state = {
            showConfirmModal: false
        }
    }

    /**
     * @description Function to open file dialog 
     * @memberof DeviceDetailsUploadComponent
     */
    showOpenFileDlg = () => {
        this.inputOpenFileRef.current.click()
    }

    render() {
        const { onSubmit, onInputChange, isLoading, resetInput, displayFileName, uploadError, fileExtentionError, disclaimerCheckBoxValue,
            maxFileSizeError, disclaimerCheckBoxChange, formErrors, isFileUploading, toggleUploadModal } = this.props;
        return (
            <div className="log-upload">
                {isLoading ? <div className="loading-overlay upload-log-overlay"><span>{actions.load}</span></div> : ''}
                <div className="body body-section">
                    <div className="file-selector-wrap">
                        <div className="form-lable"><label>Selected File<span className="red">*</span>: </label></div>
                        <div className="fileinputs form-input">
                            <input type="file" name="fileName" ref={this.inputOpenFileRef} data-testid="inputFile" id="inputFile"
                                onChange={(e) => onInputChange(e.target.files)} onClick={resetInput} className="form-control file input-file"
                                accept='text/plain' />
                            <div className="sudofile d-flex justify-content-between">
                                <input placeholder="Select File" type="text" name="fileNames" disabled defaultValue={displayFileName} className="form-control input-file m-0 log-upload-input" />
                                <button className="btn btn-outline-primary" onClick={this.showOpenFileDlg}>Browse</button>
                            </div>
                            {fileExtentionError ? (
                                <div className="error-msg">
                                    <p>{deviceMessages.selectTextFile}</p>
                                </div>
                            ) : maxFileSizeError ? (
                                <div className="error-msg">
                                    <p>{errorMessages.fileUpload.sdaMaxSizeAllowed}</p>
                                </div>
                            ) : null}
                            {formErrors.fileName && !fileExtentionError ? (
                                <div className="error-msg">
                                    <p>{formErrors.fileName}</p>
                                </div>
                            ) : <></>}
                        </div>
                    </div>

                    <div className="disclaimer-wrap">
                        <div className="form-lable facility-label"></div>
                        <div className="fileinputs form-input">
                            <div className="mrgtop-20">
                                <label className="chk-label">
                                    <input type="checkbox" data-testid="disclaimerchk" id="disclaimerchk" className="chk-input" onChange={(e) => disclaimerCheckBoxChange(e)} checked={disclaimerCheckBoxValue === true} />
                                    <span className="red ms-1">*</span>
                                    &nbsp;{errorMessages.fileUpload.sdaCheck1}<br />{errorMessages.fileUpload.sdaCheck2}
                                </label>
                            </div>
                            {formErrors && formErrors.disclaimerCheckBox ?
                                <div className="error-msg" data-tserid="disclaimer">
                                    <p>{formErrors.disclaimerCheckBox}</p>
                                </div>
                                : ''}
                        </div>
                    </div>

                    {uploadError ?
                        <div className="top-error-msg pt-2">
                            <p>{uploadError}</p>
                        </div>
                        : ''}

                    {isFileUploading ?
                        <div className="success-msg pt-2">
                            <p>{deviceMessages.fileUploadProcess}</p>
                        </div> : ''}

                    <hr />
                    <div className="btns-style text-end">
                        <button className="btn btn-primary" id="fileUpload" data-testid="uploadBtn" onClick={onSubmit} disabled={isFileUploading}>Upload</button>
                        <button className="btn btn-secondary ms-2" id="closeModal" data-testid="closeModalBtn" onClick={toggleUploadModal}>Close</button>
                    </div>
                </div>

            </div>
        );
    }
}

const mapStateToProps = (state) => ({ state })
const mapDispatchToProps = (dispatch) => ({})
export default connect(mapStateToProps, mapDispatchToProps)(DeviceDetailsUploadComponent);
